<template>
  <v-range-slider
    v-model="dateRange"
    :max="max"
    :min="min"
    hide-details
    class="align-center mt-4"
    @change="changed"
  >
    <template v-slot:prepend>
      <div
        v-if="dates && dateRange && dates[dateRange[0]]"
        style="white-space: nowrap"
        class="text-caption"
      >
       {{ dates[dateRange[0]-1] | formatShortDate }}
      </div>
    </template>
    <template v-slot:append>
      <div
        v-if="dates && dateRange && dates[dateRange[1] - 1]"
        style="white-space: nowrap"
        class="text-caption"
      >
        {{ dates[dateRange[1] - 1] | formatShortDate }}
      </div>
    </template>
  </v-range-slider>
</template>

<script>
import moment from "moment";

export default {
  props: {
    value: {
      type: Object,
      required: false,
    },
    minDate: {
      type: [Date, String],
      required: true,
    },
    maxDate: {
      type: [Date, String],
      required: true,
    },
    unit: {
      type: String, // Options are "minutes", "hours", "days" and "months"
      required: false,
      default: "days",
    },
  },
  data: () => ({
    dates: [],
    min: 1,
    max: 10,
  }),
  mounted() {
    this.dates = this.enumerateBetweenDates(
      this.minDate,
      this.maxDate,
      this.unit
    );
    this.dateRange = [1, this.dates.length];
    this.min = 1;
    this.max = this.dates.length;
  },
  methods: {
    enumerateBetweenDates(startDate, endDate, unit) {
      var dates = [];

      var currDate = moment(startDate).startOf("day");
      var lastDate = moment(endDate).startOf("day");

      while (currDate.diff(lastDate) <= 0) {
        dates.push(currDate.clone().toDate());
        currDate.add(1, unit);
      }

      return dates;
    },
    changed() {
      const start = this.dates[this.dateRange[0]-1];
      const end = this.dates[this.dateRange[1]];
      const range = [start, end];
      this.$emit("change", range);
      this.$emit("input", range);
    },
  },
};
</script>

<style></style>
